(function(){
  var KEY='hv_recent', MAX=24;
  function read(){try{return JSON.parse(localStorage.getItem(KEY)||'[]');}catch(e){return [];}}
  function write(a){try{localStorage.setItem(KEY,JSON.stringify(a));}catch(e){}}
  var meta=document.querySelector('meta[name="hv-product"]'), curHandle=meta?meta.content:'';
  if(curHandle){var l=read().filter(function(x){return x!==curHandle;});l.unshift(curHandle);write(l.slice(0,MAX));}
  function init(){
    var box=document.querySelector('.hv-recent'); if(!box||box.dataset.ready)return; box.dataset.ready='1';
    var handles=read().filter(function(h){return h&&h!==curHandle;}).slice(0,MAX); if(!handles.length)return;
    var t=box.querySelector('.related-infinite-track'), cache={}, w=box;
    box.querySelector('.related-infinite-arrow--prev').onclick=function(){t.scrollBy({left:-t.clientWidth,behavior:'smooth'})};
    box.querySelector('.related-infinite-arrow--next').onclick=function(){t.scrollBy({left:t.clientWidth,behavior:'smooth'})};
    function money(v){return '$'+parseFloat(v).toFixed(2);}
    function img(src){return src+(src.indexOf('?')>-1?'&':'?')+'width=500';}
    function esc(x){var d=document.createElement('div');d.textContent=x||'';return d.innerHTML;}
    function cardEl(p){
      var el=document.createElement('div'); el.className='hv-card related-infinite-card'; el.dataset.handle=p.handle; el.dataset.productId=p.id;
      var imgs=(p.images||[]), url='/products/'+p.handle, v=p.variants&&p.variants[0];
      var slides=imgs.map(function(i){return '<a href="'+url+'" class="hv-card__slide" tabindex="-1"><img src="'+img(i.src)+'" alt="'+esc(p.title)+'" loading="lazy"></a>';}).join('');
      var quality=(p.tags||[]).indexOf('MASTER_QUALITY')>-1; var best=(p.tags||[]).indexOf('BESTSELLER')>-1; el.innerHTML='<div class="hv-card__media">'+(quality?'<span class="hv-card__badge hv-card__badge--quality">Master Quality</span>':best?'<span class="hv-card__badge">Bestseller</span>':'')+'<div class="hv-card__slides">'+slides+'</div>'+(imgs.length>1?'<button type="button" class="hv-card__arrow hv-card__arrow--prev" aria-label="Previous image">&#10094;</button><button type="button" class="hv-card__arrow hv-card__arrow--next" aria-label="Next image">&#10095;</button><div class="hv-card__dots"></div>':'')+'</div><a href="'+url+'" class="hv-card__title">'+esc(p.title)+'</a><p class="hv-card__price">'+(v?money(v.price):'')+'</p><div class="hv-card__sw"></div><button type="button" class="hv-card__add">Quick add</button><div class="hv-card__opts" hidden></div>';
      return el;
    }
    function dots(card){
      var sl=card.querySelector('.hv-card__slides'), d=card.querySelector('.hv-card__dots'); if(!sl||!d)return;
      var n=sl.children.length, many=n>7; d.innerHTML='';
      if(many){d.classList.add('is-count');}
      else{for(var i=0;i<n;i++){d.appendChild(document.createElement('i'));}}
      function mark(){
        var k=Math.round(sl.scrollLeft/(sl.clientWidth||1));
        if(many){d.textContent=(k+1)+' / '+n;}
        else{[].forEach.call(d.children,function(x,i){x.classList.toggle('is-on',i===k);});}
      }
      sl.addEventListener('scroll',mark,{passive:true}); mark();
    }
    function setup(scope){[].forEach.call(scope.querySelectorAll('.hv-card'),function(c){if(!c.dataset.d){c.dataset.d='1';dots(c);}});}
    var collData={};
    function colorOpt(p){var o=(p.options||[]).filter(function(x){return /^colou?r$/i.test(x.name);})[0];return o||null;}
    function vImg(p,v){if(v.featured_image&&v.featured_image.src)return v.featured_image.src;var im=(p.images||[]).filter(function(i){return i.id===v.image_id;})[0];return im?im.src:null;}
    function swatchesFor(p){
      var o=colorOpt(p); if(!o)return [];
      var key='option'+o.position, seen={}, out=[];
      (p.variants||[]).forEach(function(v){var val=v[key]; if(!val||seen[val])return; var src=vImg(p,v); seen[val]=1; if(src)out.push({value:val,src:src});});
      return out;
    }
    function decorate(card,p){
      var box=card.querySelector('.hv-card__sw'); if(!box||box.dataset.d||!p)return; box.dataset.d='1';
      var sw=swatchesFor(p); if(sw.length<2){return;}
      box.classList.toggle('is-one-row',sw.length<=4);
      var wrap=document.createElement('div'); wrap.className='hv-sw-wrap'; box.parentNode.insertBefore(wrap,box); wrap.appendChild(box);
      sw.forEach(function(x){
        var b=document.createElement('button'); b.type='button'; b.className='hv-sw'; b.title=x.value; b.setAttribute('aria-label',x.value);
        b.style.backgroundImage='url('+img(x.src)+')';
        b.addEventListener('click',function(e){
          e.stopPropagation();
          [].forEach.call(box.querySelectorAll('.hv-sw'),function(y){y.classList.toggle('is-on',y===b);});
          card.dataset.color=x.value;
          var first=card.querySelector('.hv-card__slide img'), sl=card.querySelector('.hv-card__slides');
          if(first){first.src=img(x.src);} if(sl)sl.scrollTo({left:0,behavior:'smooth'});
        });
        box.appendChild(b);
      });
      var firstBtn=box.querySelector('.hv-sw'); if(firstBtn){firstBtn.classList.add('is-on'); card.dataset.color=sw[0].value;}
      var pv=document.createElement('button'); pv.type='button'; pv.className='hv-sw-arrow hv-sw-arrow--prev'; pv.setAttribute('aria-label','Previous colors'); pv.innerHTML='&#10094;';
      var nx=document.createElement('button'); nx.type='button'; nx.className='hv-sw-arrow hv-sw-arrow--next'; nx.setAttribute('aria-label','More colors'); nx.innerHTML='&#10095;';
      wrap.appendChild(pv); wrap.appendChild(nx);
      function chk(){wrap.classList.toggle('can-prev',box.scrollLeft>4);wrap.classList.toggle('can-next',box.scrollLeft+box.clientWidth<box.scrollWidth-4);}
      box.addEventListener('scroll',chk,{passive:true}); window.addEventListener('resize',chk); setTimeout(chk,60); setTimeout(chk,600);
      pv.addEventListener('click',function(e){e.stopPropagation();box.scrollBy({left:-box.clientWidth*0.8,behavior:'smooth'});});
      nx.addEventListener('click',function(e){e.stopPropagation();box.scrollBy({left:box.clientWidth*0.8,behavior:'smooth'});});
    }
    function bubble(n){
      var cb=document.querySelector('cart-icon [ref="cartBubbleCount"]'), b=document.querySelector('cart-icon [ref="cartBubble"]'), ci=document.querySelector('cart-icon');
      if(cb){cb.textContent=n<100?String(n):'';cb.classList.toggle('hidden',n===0);} if(b)b.classList.toggle('visually-hidden',n===0); if(ci)ci.classList.toggle('header-actions__cart-icon--has-cart',n>0);
    }
    function addToCart(card,id,btn){
      btn.disabled=true; btn.textContent='Adding…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
      .then(function(res){
        var o=card.querySelector('.hv-card__opts');
        if(!res.ok){btn.disabled=false;btn.textContent='Add to bag';var m=document.createElement('p');m.className='hv-card__msg';m.textContent=(res.j&&res.j.description)||'Could not add this item.';o.appendChild(m);return;}
        o.innerHTML='<p class="hv-card__msg">Added to bag &#10003; <a href="/cart">View bag</a></p>';
        fetch('/cart.js').then(function(r){return r.json();}).then(function(c){bubble(c.item_count);});
        document.dispatchEvent(new CustomEvent('hv:cart-added'));
      }).catch(function(){btn.disabled=false;btn.textContent='Add to bag';});
    }
    function openOpts(card){
      var o=card.querySelector('.hv-card__opts'); if(!o.hidden){o.hidden=true;return;}
      o.hidden=false; o.innerHTML='<p class="hv-card__msg">Loading…</p>';
      fetch('/products/'+card.dataset.handle+'.js').then(function(r){return r.json();}).then(function(p){
        o.innerHTML='';
        if(p.variants.length===1){var b1=document.createElement('button');b1.type='button';b1.className='hv-card__go';b1.textContent='Add to bag';b1.onclick=function(){addToCart(card,p.variants[0].id,b1);};o.appendChild(b1);return;}
        var chosen=p.options.map(function(){return '';});
        var go=document.createElement('button'); go.type='button'; go.className='hv-card__go'; go.textContent='Add to bag'; go.disabled=true;
        var msg=document.createElement('p'); msg.className='hv-card__msg';
        var vid=null, groups=[];
        function match(vals){return p.variants.filter(function(v){return vals.every(function(x,i){return !x||v['option'+(i+1)]===x;});});}
        function refresh(){
          groups.forEach(function(g,i){[].forEach.call(g.children,function(b){
            var val=b.dataset.v, test=chosen.slice(); test[i]=val;
            var ok=match(test).some(function(v){return v.available;});
            b.classList.toggle('is-on',chosen[i]===val);
            if(b.classList.contains('hv-pill')) b.disabled=!ok; else b.style.opacity=ok?'':'.35';
          });});
          var full=chosen.every(function(x){return x;});
          if(!full){go.disabled=true;vid=null;msg.textContent='';return;}
          var m=match(chosen)[0];
          if(!m||!m.available){go.disabled=true;vid=null;msg.textContent=m?'Sold out':'Unavailable';return;}
          msg.textContent='';vid=m.id;go.disabled=false;
        }
        p.options.forEach(function(op,i){
          var isColor=/^colou?r$/i.test(op.name);
          var pre=isColor&&card.dataset.color&&op.values.indexOf(card.dataset.color)>-1;
          var lbl=document.createElement('p'); lbl.className='hv-card__lbl'; lbl.textContent=isColor?'Color':op.name;
          var row=document.createElement('div'); row.className='hv-card__row'; groups.push(row);
          if(pre){lbl.style.display='none';row.style.display='none';}
          o.appendChild(lbl);
          op.values.forEach(function(val){
            var b=document.createElement('button'); b.type='button'; b.dataset.v=val; b.title=val;
            var vimg=null;
            if(isColor){var vv=p.variants.filter(function(v){return v['option'+(i+1)]===val&&v.featured_image;})[0]; vimg=vv&&vv.featured_image.src;}
            if(isColor&&vimg){b.className='hv-sw hv-sw--lg';b.style.backgroundImage='url('+img(vimg)+')';b.setAttribute('aria-label',val);}
            else{b.className='hv-pill';b.textContent=val;}
            b.addEventListener('click',function(){chosen[i]=(chosen[i]===val?'':val);refresh();});
            row.appendChild(b);
          });
          o.appendChild(row);
          if(isColor&&card.dataset.color&&op.values.indexOf(card.dataset.color)>-1)chosen[i]=card.dataset.color;
        });
        o.appendChild(go); o.appendChild(msg); go.onclick=function(){if(vid)addToCart(card,vid,go);};
        refresh();
        if(card.dataset.color&&vid&&!go.disabled){addToCart(card,vid,go);}
      }).catch(function(){o.innerHTML='<p class="hv-card__msg">Could not load options.</p>';});
    }
    t.addEventListener('click',function(e){
      var card=e.target.closest('.hv-card'); if(!card)return;
      var add=e.target.closest('.hv-card__add'); if(add){openOpts(card);return;}
      var ar=e.target.closest('.hv-card__arrow'); if(ar){var sl=card.querySelector('.hv-card__slides');sl.scrollBy({left:(ar.classList.contains('hv-card__arrow--next')?1:-1)*sl.clientWidth,behavior:'smooth'});}
    });

    function norm(p){
      return {id:p.id,handle:p.handle,title:p.title,tags:p.tags||[],price:p.price/100,
        images:(p.images||[]).map(function(s,i){return {id:i,src:s.indexOf('//')===0?'https:'+s:s};}),
        options:(p.options||[]).map(function(o,i){return {name:o.name,position:o.position||i+1,values:o.values};}),
        variants:(p.variants||[]).map(function(v){return {id:v.id,price:v.price/100,option1:v.option1,option2:v.option2,option3:v.option3,featured_image:v.featured_image?{src:v.featured_image.src}:null};})};
    }
    var done=0;
    Promise.all(handles.map(function(h){return fetch('/products/'+encodeURIComponent(h)+'.js').then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});})).then(function(list){
      var items=list.filter(Boolean);
      if(!items.length)return;
      items.forEach(function(raw){var p=norm(raw);var c=cardEl(p);t.appendChild(c);decorate(c,p);});
      setup(t); box.hidden=false;
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
